import { render, staticRenderFns } from "./CategoriesPage.vue?vue&type=template&id=9e86f414&"
import script from "./CategoriesPage.vue?vue&type=script&lang=js&"
export * from "./CategoriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e86f414')) {
      api.createRecord('9e86f414', component.options)
    } else {
      api.reload('9e86f414', component.options)
    }
    module.hot.accept("./CategoriesPage.vue?vue&type=template&id=9e86f414&", function () {
      api.rerender('9e86f414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/CategoriesPage.vue"
export default component.exports